var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.86,
    height: 19.718,
    viewBox: "0 0 26.86 19.718",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#000000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    id: "team_3_",
    "data-name": "team (3)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(20.604 8.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    className: "a",
    "data-name": "Path 35",
    d: "M395.845,228.911a7.677,7.677,0,0,0-2.7-.462.393.393,0,1,0,0,.787,6.8,6.8,0,0,1,2.348.379.393.393,0,1,0,.352-.7Z",
    transform: "translate(-392.751 -228.449)",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    id: "Path_36",
    "data-name": "Path 36",
    d: "M25.659,82.544l-1.625-.464a.165.165,0,0,1-.119-.158v-.542a2.957,2.957,0,0,0,.376-.309,2.9,2.9,0,0,0,.886-2.094v-.748l.157-.314A2.51,2.51,0,0,0,25.6,76.8V74.77a.393.393,0,0,0-.393-.393H21.418a2.5,2.5,0,0,0-2.5,2.5V76.9a2.087,2.087,0,0,0,.219.929l.2.4v.643A3.07,3.07,0,0,0,20.6,81.353v.568c0,.088,0,.124-.325.217l-.793.227-2.294-.834a.393.393,0,0,0-.107-.3l-.733-.77V79.167c.077-.064.154-.129.228-.2a4.618,4.618,0,0,0,1.455-3.357V74.579a4.548,4.548,0,0,0,.421-1.913V68.459a.393.393,0,0,0-.393-.393h-5.89a3.763,3.763,0,0,0-3.759,3.759v.841a4.548,4.548,0,0,0,.421,1.913v.888a4.808,4.808,0,0,0,1.683,3.669V80.46l-.733.77a.393.393,0,0,0-.107.3l-2.421.88a2.064,2.064,0,0,0-.486.255l-.38-.19A3.005,3.005,0,0,0,7.9,81.256a.393.393,0,0,0,0-.352,6.99,6.99,0,0,1-.346-2.443c-.009-.278-.018-.541-.035-.775a3.423,3.423,0,0,0-3.337-3.31,3.422,3.422,0,0,0-3.337,3.31c-.017.234-.025.5-.035.775A6.99,6.99,0,0,1,.462,80.9a.393.393,0,0,0,0,.352,3,3,0,0,0,1.509,1.219L.915,83A1.647,1.647,0,0,0,0,84.484v2.907a.393.393,0,1,0,.787,0V84.484a.864.864,0,0,1,.48-.777l1.315-.657.457.435a1.655,1.655,0,0,0,2.281,0l.457-.435.429.214a2.072,2.072,0,0,0-.316,1.1v3.028a.393.393,0,0,0,.787,0V84.362a1.293,1.293,0,0,1,.849-1.212l2.552-.928,1.062,1.594a.811.811,0,0,0,.6.359q.041,0,.081,0a.811.811,0,0,0,.575-.238l.648-.648v4.1a.393.393,0,0,0,.787,0v-4.1l.648.648a.811.811,0,0,0,.575.239q.04,0,.081,0a.811.811,0,0,0,.6-.359l1.063-1.594,2.552.928a1.293,1.293,0,0,1,.849,1.212v3.028a.393.393,0,0,0,.787,0V84.363a2.08,2.08,0,0,0-.582-1.44l.1-.028a2.158,2.158,0,0,0,.366-.132l1,1v3.623a.393.393,0,0,0,.787,0V83.768l1-1a.936.936,0,0,0,.167.066l1.625.464a.872.872,0,0,1,.63.835v3.255a.393.393,0,0,0,.787,0V84.136A1.663,1.663,0,0,0,25.659,82.544ZM2.524,81.849a2.828,2.828,0,0,1-1.263-.811,4.337,4.337,0,0,0,.224-.942,2.934,2.934,0,0,0,1.038,1.281Zm2.254,1.065a.868.868,0,0,1-1.2,0l-.366-.348a.814.814,0,0,0,.1-.384v-.419a2.926,2.926,0,0,0,1.737,0v.419a.814.814,0,0,0,.1.384Zm-.6-1.806a2.133,2.133,0,0,1-2.131-2.131.391.391,0,0,0-.458-.388l0-.1c.009-.271.017-.526.033-.745a2.921,2.921,0,0,1,.8-1.834,2.445,2.445,0,0,1,3.514,0,2.921,2.921,0,0,1,.8,1.834c.016.219.024.475.033.745l0,.07a3.535,3.535,0,0,0-1.943-1.42,4.938,4.938,0,0,0-1.5-.237.394.394,0,0,0-.272.12l-.71.736a.393.393,0,0,0,.566.546l.591-.613a3.183,3.183,0,0,1,2.782,1.617A2.126,2.126,0,0,1,4.18,81.108Zm1.655.743v-.469A2.91,2.91,0,0,0,6.874,80.1a4.332,4.332,0,0,0,.224.94A2.842,2.842,0,0,1,5.835,81.85Zm3.786-6.383v-.976a.393.393,0,0,0-.039-.171A3.774,3.774,0,0,1,9.2,72.666v-.841a2.975,2.975,0,0,1,2.972-2.972h5.5v3.813a3.774,3.774,0,0,1-.382,1.653.393.393,0,0,0-.039.171v1.12a3.777,3.777,0,0,1-1.206,2.783,3.916,3.916,0,0,1-.3.256l-.007,0a3.783,3.783,0,0,1-2.553.762A3.9,3.9,0,0,1,9.622,75.467Zm2.215,7.917a.025.025,0,0,1-.022.008.025.025,0,0,1-.02-.012l-1.224-1.836.394-.414L12.821,82.4Zm1.6-1.518L11.3,80.409v-.734a4.43,4.43,0,0,0,1.825.527q.156.01.31.01a4.558,4.558,0,0,0,2.127-.521v.719Zm1.64,1.514a.025.025,0,0,1-.02.012.024.024,0,0,1-.022-.008l-.985-.985L15.9,81.131l.394.414Zm7.185-.332-.893-.893a1.08,1.08,0,0,0,.024-.234v-.166a2.759,2.759,0,0,0,.779.138h.091a2.923,2.923,0,0,0,.867-.131v.158a.941.941,0,0,0,.028.229Zm1.484-2.542a2.115,2.115,0,0,1-1.55.6,2.2,2.2,0,0,1-2.065-2.236v-.736a.393.393,0,0,0-.042-.176l-.243-.486a1.3,1.3,0,0,1-.136-.577v-.023a1.712,1.712,0,0,1,1.71-1.71h3.393V76.8a1.719,1.719,0,0,1-.181.765l-.2.4a.393.393,0,0,0-.042.176v.841A2.114,2.114,0,0,1,23.743,80.506Z",
    transform: "translate(0 -68.066)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(24.39 16.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    className: "a",
    "data-name": "Path 37",
    d: "M465.316,380.814a.393.393,0,0,0-.393.393v2.524a.393.393,0,0,0,.787,0v-2.524A.394.394,0,0,0,465.316,380.814Z",
    transform: "translate(-464.923 -380.814)",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(1.683 16.927)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    className: "a",
    "data-name": "Path 38",
    d: "M32.47,390.728a.393.393,0,0,0-.393.393v2a.393.393,0,0,0,.787,0v-2A.393.393,0,0,0,32.47,390.728Z",
    transform: "translate(-32.077 -390.728)",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(10.097 3.575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    className: "a",
    "data-name": "Path 39",
    d: "M199.021,137.371c-1.488-1.488-4.6-1.2-5.871-1.012a.808.808,0,0,0-.69.8v.906a.393.393,0,1,0,.787,0v-.906a.026.026,0,0,1,.021-.027,12.43,12.43,0,0,1,2.556-.125,4.061,4.061,0,0,1,2.641.915.393.393,0,1,0,.556-.556Z",
    transform: "translate(-192.46 -136.203)",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(8.414 17.249)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    className: "a",
    "data-name": "Path 40",
    d: "M160.777,396.853a.393.393,0,0,0-.393.393v1.683a.393.393,0,0,0,.787,0v-1.683A.393.393,0,0,0,160.777,396.853Z",
    transform: "translate(-160.384 -396.853)",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(17.669 17.249)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    className: "a",
    "data-name": "Path 41",
    d: "M337.2,396.853a.393.393,0,0,0-.393.393v1.683a.393.393,0,0,0,.787,0v-1.683A.393.393,0,0,0,337.2,396.853Z",
    transform: "translate(-336.806 -396.853)",
    fill: "#707070"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.7e7cedc8d214ef083edb90bae58d0acc.svg";
export { ForwardRef as ReactComponent };